import { render, staticRenderFns } from "./UfoLogo.vue?vue&type=template&id=50a4697d&scoped=true"
import script from "./UfoLogo.vue?vue&type=script&lang=js"
export * from "./UfoLogo.vue?vue&type=script&lang=js"
import style0 from "./UfoLogo.vue?vue&type=style&index=0&id=50a4697d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a4697d",
  null
  
)

export default component.exports